import { DisclosureMenu } from 'accessible-menu';

document.addEventListener("DOMContentLoaded", () => {
    const containerElement = document.querySelector(".wp-block-megamenu");
    const menuElement = containerElement.querySelector(".wp-block-megamenu__items");
    const navToggle = document.querySelector('.wp-block-megamenu > button');

    window.megamenuBlocks = new DisclosureMenu({
        menuElement,
        submenuItemSelector: ".has-megamenu",
        containerElement,
        controllerElement: navToggle,
        optionalKeySupport: true,
        openClass: "is-visible",
        closeClass: "is-hidden",
        hoverType: "off"
    });

    const menuItemsWithDrawer = document.querySelectorAll('.wp-block-megamenu__items a[aria-haspopup="true"]');

    menuItemsWithDrawer.forEach((item) => {
        item.addEventListener('click', (e) => e.preventDefault());
    });
});